import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import TameeniLoaderOverlay from '@/components/tameeni-loader/tameeni-loader-overlay'

/**
 * Short-url resolver for links like /sl/abc123 (from SMS/email).
 *
 * Mirrors the old Next.js middleware: hard-navigate the browser to
 * `/backend/sl/abc123` on the SAME origin. The site's ingress proxies
 * `/backend/*` to the API, whose short-url resolver then issues its own
 * redirect to the real destination. Query string + hash are preserved.
 *
 * Replaces the old middleware `/sl/` rewrite without any nginx config —
 * it's a normal route in App.tsx (`/sl/*`).
 */
export default function ShortUrlRedirect() {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    // /sl/abc123 -> /backend/sl/abc123 (same origin, relative path).
    const target = `/backend${pathname}${search}${hash}`
    window.location.replace(target)
  }, [pathname, search, hash])

  // Show the loader while the browser performs the hard redirect.
  return <TameeniLoaderOverlay transparent={false} />
}
